module.exports = __webpack_public_path__ + "images/emoji/first_quarter_moon.9e0fa8fdba7be4e1df62.png";